import {
    COMMON
} from '../constants/funcUrl'

const commonMutation = {
  [COMMON.LOCALMODULE](state, data) {
    state.module = data;
  },
  [COMMON.COURSE](state, data) {
    state.courses = data;
  },
  [COMMON.LOGIN](state, data) {
    state.login = data;
  },
  [COMMON.COURSEDETAILS](state, data) {
    state.courseDetails = data;
  },
  [COMMON.COURSEOPENJOBS](state, data) {
    state.courseOpenJobs = data;
  },
  [COMMON.CERT](state, data) {
    state.certs = data;
  },
  [COMMON.GETENTERPRISEREGISTRATION](state, data) {
    state.enterprise = data;
  },
  [COMMON.EMPLOYEETITLE](state, data) {
    state.employeeTitle = data;
  },
  [COMMON.CERTCLASS](state, data) {
    state.certClass = data;
  },
  [COMMON.CERTSUBCLASS](state, data) {
    state.certSubClass = data;
  },
  [COMMON.JOB](state, data) {
    state.jobs = data;
  },
  [COMMON.LEARNLEARNDETAILS](state, data) {
    _.forEach(data.LearnJobAndEmployees, item => {
      item.BusinessType = null;
      if (item.JobName && item.JobName.indexOf('B') > 0) {
        item.BusinessType = 'B';
      }
      if (item.JobName && item.JobName.indexOf('C') > 0) {
        item.BusinessType = 'C';
      }
    });
    state.learnDetails = data;
  },
  [COMMON.LEARNLEARNAPPROVESTEP](state, data) {
    state.learnApproveStep = data;
  },
  [COMMON.COMMONLEARNPAYMETHOD](state, data) {
    state.learnPayMethod = data;
  },
  [COMMON.COMMONMAKEUPPAYMETHOD](state, data) {
    state.makeUpPayMethod = data;
  },
  [COMMON.MAKEUPMAKEUPDETAILS](state, data) {
    state.makeUpDetails = data;
  },
  [COMMON.MAKEUPMAKEUPAPPROVESTEP](state, data) {
    state.makeUpApproveStep = data;
  },
  [COMMON.NEWS](state, data) {
    state.news = data;
  },
  [COMMON.NEWSDETAILS](state, data) {
    state.newsDetails = data;
  },
  [COMMON.NEWSSUSPLAYER](state, data) {
    state.newsSusplayer = data;
  },
  [COMMON.NEWSTESTPLANS](state, data) {
    state.newsTestPlans = data;
  },
  [COMMON.COURSERECOMMEND](state, data) {
    state.courseRecommends = data;
  },
  [COMMON.EMPLOYEEDEGREE](state, data) {
    state.employeeDegree = data;
  },
  [COMMON.LEARNLEARNAPPROVECOUNT1](state, data) {
    state.learnApproveCount1 = data;
  },
  [COMMON.LEARNLEARNAPPROVECOUNT2](state, data) {
    state.learnApproveCount2 = data;
  },
  [COMMON.LEARNLEARNAPPROVECOUNT3](state, data) {
    state.learnApproveCount3 = data;
  },
  [COMMON.MAKEUPMAKEUPAPPROVECOUNT1](state, data) {
    state.makeUpApproveCount1 = data;
  },
  [COMMON.MAKEUPMAKEUPAPPROVECOUNT2](state, data) {
    state.makeUpApproveCount2 = data;
  },
  [COMMON.MAKEUPMAKEUPAPPROVECOUNT3](state, data) {
    state.makeUpApproveCount3 = data;
  },
  [COMMON.LEARNINGMGTDETAILS](state, data) {
    state.learningmgtDetails = data;
  },
  [COMMON.COMMONJOB](state, data) {
    state.commonJob = data;
  },
  [COMMON.STUDYRECORDDETAILS](state, data) {
    state.studyRecordDetails = data;
  },
  [COMMON.INVOICEAPPROVEADETAILS](state, data) {
    state.invoiceApproveDetails = data;
  },
  [COMMON.COMMONQUICKCOMMENTS](state, data) {
    state.quickComments = data;
  },
  [COMMON.WEIXINTMPQRCODE](state, data) {
    state.weiXinTmpQrCode = data;
  }
};

export default commonMutation;



// WEBPACK FOOTER //
// ./src/store/jzjy/mutations/commonMutation.js